import moment from 'moment';

const DATE_FORMAT = 'YYYY-MM-DD';

export default function(today) {
  let start_date = moment(today).startOf('month').format(DATE_FORMAT);
  let end_date = moment(today).endOf('month').format(DATE_FORMAT);

  if (!today instanceof Date) {
    throw new Error (`today must be an instance of Date.`);
  }

  return {
    start_date,
    end_date,
    page_or_not: 0
  };

}



// WEBPACK FOOTER //
// ./src/containers/pages/Schedule/getScheduleOption.js